import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { DataOrigin } from '../../model/DataOrigin';
import { UserNewDataService } from './usernew-data.service';
import { UserNewMockService } from './usernew-data-mock.service';
import { UserNewDataMobileService } from './usernew-data-mobile.service';

@Injectable({
  providedIn: 'root',
})
export abstract class UserNewFactoryService {
  private services = new Map<DataOrigin, UserNewDataService>();

  constructor(private handlerService: HandlerService) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): UserNewDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new UserNewDataMobileService(this.handlerService);
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new UserNewMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new UserNewMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
